<template>
    <div class="row m-b-sm">
        <div class="col-lg-12">
            <div class="float-e-margins">
                <div class="file-manager">
                    <form :id="'dropzone-' + id" class="dropzone-box mediapool-dropzone-scrollbox">
                        <div class="dz-default dz-message">
                            <span>{{ t_drop_upload }}</span>
                        </div>
                    </form>
                    <div class="upload-warning"
                         @mouseover="warningHover = true"
                         @mouseleave="warningHover = false">
                        <div v-if="warningHover" class="alert alert-warning text-center">
                            {{ t_waiting }}
                        </div>
                        <i :class="uploadingCount > 0 ? 'text-warning' : ''" class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                    </div>
                    <div class="upload-info"
                         @mouseover="infoHover = true"
                         @mouseleave="infoHover = false">
                        <div v-if="infoHover" class="alert alert-info">
                            <file-type-name-limit-list :additional-list-items="[t_video_encoding_limitation]"/>
                        </div>
                        <i :class="erroneousUploads > 0 ? 'text-danger' : ''" class="fa-solid fa-circle-info" aria-hidden="true" style="z-index: 2;"></i>
                    </div>
                    <v-btn class="btn btn-primary btn-block mediapool-fileinput-button m-t-sm">{{ t_upload }}</v-btn>
                </div>
            </div>
        </div>
        <div class="table mediapool-dropzone-preview table-striped files hidden" id="mediapool-preview">
            <div id="template" class="file-row">
                <div>
                    <strong class="error text-danger" data-dz-errormessage></strong>
                </div>
                <div class="progress mediapool-dropzone-progress progress-striped active">
                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" role="progressbar" class="progress-bar"
                         data-dz-uploadprogress>
                        <p class="name mediapool-dropzone-filename mediapool-wrap-text" data-dz-name></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileTypeNameLimitList from '../../common/alert/file-type-name-limit-list.vue'
    import Dropzone from "@deltablot/dropzone";
    import emojiRegex from 'emoji-regex';

    export default {
        components: { FileTypeNameLimitList },
        props: ['id'],
        data() {
            return {
                t_upload: Lang.langGet("Upload Files"),
                t_drop_upload: Lang.langGet("Drop files here to upload"),
                t_unknown: Lang.langGet("Unknown"),
                t_invalid: Lang.langGet("You can't upload files of this type."),
                t_video_encoding_limitation: Lang.langGet("Only H.264 encoded videos are supported."),
                t_waiting: Lang.langGet("Depending on file size it may take some minutes to process the upload."),
                t_error: Lang.langChoice("Error|Errors", 1),
                fileReference: 0,
                dropzoneObject: null,
                infoHover: false,
                warningHover: false,
                erroneousUploads: 0,
                uploadingCount: 0,
            }
        },
        methods: {
            filename_limitation(matches) {
                return Lang.langGet("File name contains illegal symbols: ' :matches '", {matches: matches});
            },
            reset() {
                this.init();
            },
            increaseFileReference() {
                this.fileReference += 1;

                if (this.fileReference > 0) {
                    $('#dropzone-' + this.id + ' .dz-message').addClass('hidden');
                }
            },
            decreaseFileReference() {
                this.fileReference -= 1;

                if (this.fileReference <= 0) {
                    $('#dropzone-' + this.id + ' .dz-message').removeClass('hidden');
                }
            },
            init() {
                this.dropzoneObject = new Dropzone('#dropzone-' + this.id, {
                    url: '/content/mediapool/upload',
                    paramName: 'file',
                    timeout: 300000,
                    parallelUploads: 1,
                    chunking: true,
                    chunkSize: 2000000,
                    retryChunks: true,
                    retryChunksLimit: 3,
                    maxFiles: Laravel.allowedMaxFiles,
                    dictMaxFilesExceeded: this.t_max_files,
                    maxFilesize: Laravel.upload_max_filesize,
                    previewTemplate: document.getElementById('mediapool-preview').innerHTML,
                    acceptedFiles: Laravel.allowedFileTypes.join(','),
                    dictInvalidFileType: this.t_invalid,
                    headers: {
                        'X-CSRF-TOKEN': Laravel.csrfToken
                    },
                    dictDefaultMessage: Lang.langGet("Drop files here to upload"),
                    clickable: '.mediapool-fileinput-button',
                    'error': (file, response) => {
                        if(file.previewElement) {
                            let message = $(file.previewElement).find('.mediapool-dropzone-filename').html();
                            if(typeof response === "object") {
                                message = message + ': ' + this.t_error;
                            } else {
                                message = message + ': ' + response;
                            }
                            $(file.previewElement).find('.mediapool-dropzone-filename').html(message);
                            $(file.previewElement).find('.mediapool-dropzone-filename').addClass('bg-danger');
                            $(file.previewElement).find('[role=progressbar]').css('width', '100%');
                            $(file.previewElement).find('[role=progressbar]').addClass('progress-bar-danger');
                        }
                    },
                    'chunksUploaded': function (file, done) {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.dz-processing .progress.active .progress-bar').style.width = '100%';
                        }
                        done();
                    },
                    'uploadprogress': function (file, progress, bytesSent) {
                        if(file.previewElement && progress < 100) {
                            file.previewElement.querySelector('.progress.active .progress-bar').style.width = progress + '%';
                        }
                    },
                    'complete': (file) => {
                        let timeout = 0;

                        this.uploadingCount--;
                        if (file.status === 'error') {
                            this.erroneousUploads++;
                        } else {
                            setTimeout(() => {
                                this.dropzoneObject.removeFile(file);
                                this.decreaseFileReference();
                            }, timeout);
                        }
                    },
                    'success': (data) => {
                        let json = data.xhr.responseText;

                        const firstChar = json.charAt(0);

                        if (firstChar !== '{') {
                           console.warn('Uploaded file was not in a json format. Tried to fix it');
                           json = '{"data":{"elements":{' + json.split('{').pop();
                        }

                        const responseData = JSON.parse(json);

                        if (typeof responseData.data === 'string') {
                            let message = $(data.previewElement).find('.mediapool-dropzone-filename').html();
                            message = message + ': ' + this.t_unknown + ': ' + responseData.data;
                            $(data.previewElement).find('.mediapool-dropzone-filename').html(message);
                            data.status = 'error';
                        } else {
                            this.$emit('uploaded', json);
                        }
                    },
                    'accept': (file, done) => {
                        this.clearFailed();

                        const { isInvalid, matchstring } = this.validateFilename(file.name);

                        if(isInvalid) {
                            done(this.filename_limitation(matchstring));
                        } else {
                            done();
                        }
                    },
                    'renameFile': (file) => {
                        name = this.rejectFunkyWhitespaces(file.name);
                        return this.rejectEmojis(name);
                    }
                });

                this.dropzoneObject.on('addedfile', (file) => {
                    this.uploadingCount++;
                    this.increaseFileReference();
                });

            },
            cancelUpload: function () {
                this.dropzoneObject.removeAllFiles(true);
            },
            clearFailed: function() {
                if(this.dropzoneObject !== null) {
                    let files = this.dropzoneObject.files;
                    for (let i = 0; i < files.length; i++) {
                        if(files[i].status === 'error' /*&& files[i].upload.progress > 100*/) {
                            this.dropzoneObject.removeFile(files[i]);
                            this.decreaseFileReference();
                            this.erroneousUploads--;
                        }
                    }
                }
            },
            rejectEmojis: function(filename) {
                const regex = emojiRegex();
                return filename.replace(regex, '');
            },
            rejectFunkyWhitespaces: function(filename) {
                // Normalize Unicode
                filename = filename.normalize('NFC');
                // Invisible Unicode characters (zero-width etc.)
                const invisibleChars = RegExp('[\u200B-\u200F\uFEFF]', 'gu');
                if (invisibleChars.test(filename)) {
                    filename = filename.replace(invisibleChars, '');
                }

                return filename;
            },
            validateFilename: function(filename) {
                //  pregex   /^[ _  ]/   => must not start with _
                const pregex = /^[\x5F]/;
                //  regex                  '[  "   *   /   :   <   >   ?   \   | ]' => do not allow those symbols
                const regex = RegExp('[\x22\x2A\x2F\x3A\x3C\x3E\x3F\x5C\x7C]', 'g');
                // ddregex                   '[ .  ]{2,}' => must not contain 2 or more . in sequence
                const ddregex = RegExp('[\x2E]{2,}', 'g');
                const uregex = Laravel.filenameRegex ? RegExp(Laravel.filenameRegex, 'g') : regex;

                let matchstring = '';
                const match = RegExp.prototype[Symbol.match].call(pregex, filename);
                const matches = RegExp.prototype[Symbol.matchAll].call(regex, filename);
                const result = RegExp.prototype[Symbol.matchAll].call(uregex, filename);
                const ddmatch = RegExp.prototype[Symbol.matchAll].call(ddregex, filename);
                if(match)   matchstring += '_';
                if(matches) matchstring += Array.from(matches).join(', ');
                if(result)  matchstring +=  Array.from(result).join(', ');
                if(ddmatch) matchstring += '..';

                const isInvalid = pregex.test(filename) ||
                    regex.test(filename) ||
                    uregex.test(filename) ||
                    ddregex.test(filename);

                return { isInvalid, matchstring };
            }
        },
        mounted() {
            this.init();

            EaseEventBus.listen('cancelUpload', () => {
                this.cancelUpload();
            });
        },
        watch: {
            uploadingCount(newValue) {
                this.$emit('filesToUpload', newValue);
            }
        }
    }
</script>
